import styled from "styled-components";
import { CONTENT_Z_INDEX } from "../../../../../../utils";
import { FlexRowSpaced } from "../../../../../Common/Styles";
import { usePostCardContext } from "../PostCardContent";
import { HeaderLeft } from "./1-HeaderLeft";
import { HeaderRight } from "./2-HeaderRight";

export const Header = () => {
  const { isOnExpandedPostView } = usePostCardContext();

  const Container = isOnExpandedPostView ? StickyContainer : DefaultContainer;
  return (
    <Container>
      <HeaderLeft />
      <HeaderRight />
    </Container>
  );
};

const DefaultContainer = styled(FlexRowSpaced)`
  padding: ${({ theme }) => theme.spacing["spacing-4"].value}rem;
  padding-bottom: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
  background: ${({ theme }) =>
    theme.Color.elevation.surface["surface-primary"].value};
  border-radius: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
`;
const StickyContainer = styled(DefaultContainer)`
  position: sticky;
  top: 0;
  z-index: ${CONTENT_Z_INDEX};
`;
